<template>
  <div>
    <div class="top-tool">
      <el-row type="flex">
        <el-col :span="3">
          <img src="@/assets/images/logo.png" class="logo">
        </el-col>
        <el-col :span="21" class="right-main">
          <span>欢迎您:{{adminUser.real_name}}({{adminUser.group_name}})</span>
          <el-switch
            v-model="orderReminderEnabled"
            active-text="新订单语音提醒"
            inactive-text=""
            size="mini"
            style="margin-right: 20px"
            :active-color="orderReminderEnabled ? '#409EFF' : '#C0CCDA'"
            :inactive-color="orderReminderEnabled ? '#409EFF' : '#C0CCDA'"
            @change="toggleOrderReminder">
          </el-switch>
          <el-badge :value="orderStat.refunding" :max="99" class="notice">
            <el-button size="mini" @click="redirect('refund.refund_list')">未处理退款</el-button>
          </el-badge>
          <el-badge :value="orderStat.resolve" :max="99" class="notice">
            <el-button size="mini"  @click="redirect('order.order_list.ship')">未处理船票</el-button>
          </el-badge>
          <el-badge :value="todayCommunicateCount" :max="99" class="notice">
            <el-button size="mini" type="success" @click="redirect('dashboard.communicate_stat')">今日沟通</el-button>
          </el-badge>
          <span class="option" @click="showPwdDialog">修改密码</span>
          <span class="option" @click="logout">退出</span>
        </el-col>
      </el-row>
    </div>
    <div class="page-container">
      <div class="left-menu">
        <ul>
          <div v-for="(menu, index) in leftMenu" :key="index" v-if="menu.children.length === 0 || hasVisibleChildren(menu)">
            <li class="level-one"
                :is-link="menu.routerName ? 'true':'false'"
                @click="menu.children.length > 0 ? toggleMenu(index) : redirect(menu.routerName)">
              <a href="#" v-if="menu.children.length <= 0" :class="{active:menu.selected}" @click.prevent>
                <i class="iconfont icon"
                   :class="[menu.selected?'icon-active':'icon', menu.icon]"></i>{{menu.title}}
              </a>
              <span v-else class="menu-group-title">
                <i class="iconfont icon" :class="menu.icon"></i> {{menu.title}}
                <i class="collapse-arrow" :class="{'is-expanded': !collapsedMenus[index]}">&#9656;</i>
              </span>
            </li>
            <template v-if="menu.children.length > 0 && !collapsedMenus[index]">
              <li class="level-two"
                  v-for="(subMenu, subIndex) in menu.children"
                  :key="subIndex"
                  v-if="privilegeIds.indexOf(subMenu.privilege_id) !== -1"
                  @click="redirect(subMenu.routerName)">
                <router-link :class="{active:subMenu.selected}" :to="{name:subMenu.routerName}">{{subMenu.title}}</router-link>
              </li>
            </template>
            <div class="split-line"><span></span></div>
          </div>
        </ul>
      </div>
      <div class="content">
        <div class="inner">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <div class="footer-container">
      <div class="info">
        咪咕猫(厦门)旅游科技有限责任公司 版权所有 &copy2019-2024 All Rights Reserved
      </div>
    </div>
    <el-dialog title="修改密码"
               :visible.sync="showPwd"
               :append-to-body="true"
               width="500px">
      <el-form :data="fields" size="small" :rules="validateRules" label-width="65px">
        <el-form-item label="旧密码" prop="old_password">
          <el-input type="password" v-model="fields.old_password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input type="password" v-model="fields.new_password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="showPwd = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="doEdit" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import leftMenuConfig from '@/config/left_menu'
  import {mapGetters, mapMutations} from 'vuex'
  import OrderReminderService from '@/services/orderReminderService'

  export default {
    name: "layout",
    data: function () {
      return {
        loading: false,
        adminUser: {},
        showPwd: false,
        collapsedMenus: {},
        orderStat:{
          resolve:0,
          refunding:0,
        },
        todayCommunicateCount: 0,
        fields: {
          old_password: '',
          new_password: '',
        },
        validateRules: {
          old_password: [
            {required: true, message: '请输入旧密码', trigger: 'blue'},
          ],
          new_password: [
            {required: true, message: '请输入旧密码', trigger: 'blue'},
          ]
        }
      }
    },
    methods: {
      ...mapMutations([
        'setOrderReminderEnabled',
        'setLastOrderId',
        'setReminderIntervalId'
      ]),
      redirect: function (routerName) {
        if (routerName) {
          this.$router.push({name: routerName});
        }
      },
      toggleOrderReminder: function (enabled) {
        if (enabled) {
          // 开启订单提醒
          OrderReminderService.startReminder();
        } else {
          // 关闭订单提醒
          OrderReminderService.stopReminder();
        }
      },
      hasVisibleChildren: function (menu) {
        return menu.children.some(sub => this.privilegeIds.indexOf(sub.privilege_id) !== -1);
      },
      toggleMenu: function (index) {
        this.$set(this.collapsedMenus, index, !this.collapsedMenus[index]);
        localStorage.setItem('menuCollapsed', JSON.stringify(this.collapsedMenus));
      },
      init: function () {
        this.$store.commit('leftMenu', leftMenuConfig);
        this.adminUser = JSON.parse(localStorage.getItem('user'));
        const saved = localStorage.getItem('menuCollapsed');
        if (saved) {
          this.collapsedMenus = JSON.parse(saved);
        } else {
          const collapsed = {};
          leftMenuConfig.forEach((menu, index) => {
            if (menu.children && menu.children.length > 0) {
              collapsed[index] = true;
            }
          });
          this.collapsedMenus = collapsed;
          localStorage.setItem('menuCollapsed', JSON.stringify(collapsed));
        }
      },
      logout: function () {
        this.$http.request('adminLogout').then(res => {
          if (res.status === 'success') {
            localStorage.removeItem('user');
            this.$router.push({name: 'login'});
          }
        });
      },
      showPwdDialog: function () {
        this.showPwd = true;
        this.fields = {
          old_password: '',
          new_password: '',
        }
      },
      getOrderStat:function (){
        this.$http.request('orderStat').then(res=>{
          this.orderStat = res.data;
        })
      },
      getTodayCommunicateCount: function () {
        this.$http.request('todayCommunicateCount').then(res => {
          if (res.status === 'success') {
            this.todayCommunicateCount = res.data.count || 0;
          }
        });
      },
      doEdit: function () {
        this.loading = true;
        let _self = this;
        this.$http.request('editPwd', this.fields).then(res => {
          this.loading = false;
          if (res.status === 'success') {
            this.$message({
              message: '密码修改成功,现在退出后请用新密码登录', type: "success", onClose: function () {
                _self.logout();
              }
            });
          }
        });
      }
    },
    created: function () {
      this.init();
      this.getOrderStat();
      this.getTodayCommunicateCount();
    },
    computed: {
      ...mapGetters([
        'leftMenu','privilegeIds', 'orderReminder'
      ]),
      orderReminderEnabled: {
        get() {
          return this.orderReminder.enabled;
        },
        set(value) {
          this.setOrderReminderEnabled(value);
        }
      }
    },
  }
</script>

<style scoped lang="less">

  .top-tool {
    width: 100%;
    height: 80px;
    box-shadow: 0 2px 2px #e6e6e6;
    background: #fff;
    padding: 15px 70px 0 70px;
  }

  .top-tool .logo {
    width: 90%;
  }

  .top-tool .right-main {
    text-align: right;
    align-content: center;
    font-size: 13px;
    padding-top: 15px;
  }

  .top-tool .right-main span {
    margin: 0 5px;
  }

  .top-tool .right-main .option {
    color: @main-color;
    cursor: pointer;
  }

  .top-tool .right-main .username {
    font-weight: bold;
  }

  .left-menu {
    max-width: 260px;
    width: 20%;
    min-height: 300px;
    border-right: 1px solid #dfdfdf;
    float: left;
  }

  .left-menu li.level-one .icon {
    position: absolute;
    left: 70px;
    font-size: 20px;
    color: #9a9a9a;
  }

  .left-menu li.level-one i.icon-active {
    color: @main-color !important;
  }

  .left-menu li.level-one {
    font-size: 16px;
    position: relative;
    cursor: pointer;
  }

  .left-menu li.level-one .menu-group-title {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .left-menu li.level-one .collapse-arrow {
    margin-left: auto;
    padding-right: 16px;
    font-style: normal;
    font-size: 18px;
    color: #666;
    display: inline-block;
    transform: rotate(0deg);
    transition: transform 0.25s ease;
  }

  .left-menu li.level-one .collapse-arrow.is-expanded {
    transform: rotate(90deg);
  }

  .left-menu li.level-two {
    font-size: 14px;
  }

  .left-menu .split-line {
    padding-left: 100px;
  }

  .left-menu .split-line span {
    display: inline-block;
    width: 90px;
    border-top: 1px solid @border-color;
  }

  .left-menu li {
    list-style: none;
    padding-left: 100px;
    height: 40px;
    line-height: 40px;
    margin: 5px 0;
  }

  .left-menu li a.active {
    color: @main-color;
  }

  .left-menu li a {
    color: @main-text-color;
  }

  .left-menu li.level-two:hover, .left-menu li.level-one:hover {
    background: #eee;
    cursor: pointer;
  }

  .content {
    float: left;
    width: 80%;
    min-width: 1000px;
  }

  .content .inner {
    min-width: 800px;
    width: 90%;
    margin: 0 auto;
    min-height: 700px;
  }

  .page-container {
    margin-top: 40px;
    overflow: hidden;
    min-width: 1260px;
  }

  .footer-container {
    height: 80px;
    padding-left: 260px;
  }

  .footer-container .info {
    display: inline-block;
    height: 80px;
    border-top: 1px solid @border-color;
    line-height: 80px;
    text-align: center;
    font-size: @normal-text-font-size;
    width: 100%;
  }
  .notice{margin-right: 20px}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue